import React from "react";
import Modal from "./Modal";
import { useDispatch } from "react-redux";
import { openPopup } from "../../reducers/popup";

const ModalInfo = () => {
  const dispatch = useDispatch();
  const hidePopupInfoRule = () => {
    dispatch(openPopup({}));
  };

  return (
    <Modal onClose={hidePopupInfoRule}>
      <div className="w-full lg:w-[920px] max-w-[94%] mx-auto bg-[#000] border-[2px] border-[#60c7f6] relative z-20 py-4 pt-6 lg:p-7">
        <div className="p-3 lg:p-4">
          <div className="bg-gradient-to-b from-white to-[#60c7f6] bg-clip-text text-transparent text-[22px] md:text-[28px] lg:text-28 uppercase text-center font-bold mb-[12px] lg:mb-[32px]">
            THỂ LỆ CHƯƠNG TRÌNH
          </div>
          <div className="overflow-y-auto overscroll-y-contain max-h-[60vh] scrollbar">
            <ol className="list-decimal text-white text-[15px] lg:text-18 pl-5">
              <li className="mb-3">
                <div className="font-bold uppercase">GIỚI THIỆU CHUNG</div>
                <ul className="list-[disc] pl-3">
                  <li>
                    VieON là cổng bình chọn duy nhất dành cho các khán giả tham gia tìm ra Nhóm Nhạc Toàn Năng và Quán Quân cho chương trình Anh Trai “Say Hi”.
                  </li>
                </ul>
              </li>
              <li className="mb-3">
                <div className="">
                  <div className="inline-block font-bold uppercase">
                    THỜI GIAN BÌNH CHỌN
                  </div>{" "}
                  <div>
                    Thời gian bình chọn bắt đầu từ 20h00 ngày 31/08/2024 đến 22h00 ngày 14/09/2024 với 3 đợt bình chọn như sau:
                    <ul className="list-[disc] pl-3">
                      <li>Đợt 1: Từ 20h00 ngày 31/08/2024 đến 20h00 ngày 03/09/2024, mở bình chọn cho 8 Anh Trai trình diễn đầu tiên: RHYDER, Quân A.P, HIEUTHUHAI, Erik, Negav, Captain, Song Luân, Anh Tú Atus.
                      </li>
                      <li>
                        Đợt 2: Từ 20h00 ngày 07/09/2024 đến 20h00 ngày 10/09/2024, mở bình chọn cho 8 Anh Trai trình diễn tiếp theo: Đức Phúc, Dương Domic, Pháp Kiều, Isaac, JSOL, Anh Tú, Quang Hùng MasterD, HURRYKNG.
                      </li>
                      <li>
                        Đợt 3: Từ 20h30 ngày 10/09/2024 đến 22h00 ngày 14/09/2024, mở bình chọn cho tất cả 16 Anh Trai.
                      </li>
                    </ul>
                    <div>
                      <i>
                        *Lưu ý: Trong thời gian mở bình chọn Đợt 2 BTC sẽ đóng bình chọn cho Đợt 1.
                      </i>
                    </div>
                  </div>
                </div>
              </li>
              <div className="mb-3">
                <div className="font-bold uppercase">CÁC GIẢI THƯỞNG SAU SẼ ĐƯỢC XỨNG DANH:</div>
                <ul className="list-[disc] pl-3">
                  <li>
                    Nhóm Nhạc Toàn Năng: được xác định là các Anh Trai có số lượt bình chọn cao nhất.
                  </li>
                  <li>
                    Quán Quân: được xác định là Anh Trai có số lượt bình chọn cao nhất. </li>
                </ul>
              </div>
              <li className="mb-3">
                <div className="font-bold uppercase">ĐỐI TƯỢNG THAM GIA</div>
                <ul className="list-[disc] pl-3">
                  <li>
                    Users có tài khoản VieON hợp lệ
                  </li>
                </ul>
              </li>
              <li className="mb-3">
                <div className="inline-block mb-2 font-bold uppercase">
                  HƯỚNG DẪN BÌNH CHỌN:
                </div>
                <div className="">
                  Khán giả bình chọn cho Anh Trai mình yêu thích thông qua ứng dụng VieON.
                </div>
                <ul className="list-[disc] pl-3">
                  <li>Bước 1: Truy cập ứng dụng VieON.</li>
                  <li>
                    Bước 2: Nhấp vào nút “Bình chọn ATSH” (Icon màu xanh có logo chương trình, bên góc phải màn hình).
                  </li>
                  <li>
                    Bước 3: Đăng nhập tài khoản VieON (Bỏ qua nếu đã đăng nhập)
                  </li>
                  <li>Bước 4: Nhấp vào nút bình chọn Anh Trai mà bạn yêu thích.</li>
                </ul>

                <div>
                  <div className="">
                    Số lượt bình chọn cụ thể dành cho các khách hàng:
                  </div>
                  <ul className="list-[disc] pl-3">
                    <li>
                      01 lượt bình chọn 01 ngày: dành cho khách hàng có tài khoản VieON miễn phí.
                    </li>
                    <li>
                      05 lượt bình chọn 01 ngày: dành cho khách hàng có tài khoản VieON VIP, VIP HBO GO, SPORT K+, ALL ACCESS hoặc khách hàng Mobifone gói MFV250.
                    </li>
                  </ul>
                </div>
                <div>
                  *Lưu ý:
                  <ul className="list-[disc] list-inside pl-4">
                    <li>
                      Nếu khách hàng không sử dụng hết lượt bình chọn trong ngày, số lượt bình chọn sẽ bị xoá và không được cộng dồn qua các ngày hôm sau.
                    </li>
                    <li>
                      Khách hàng muốn đăng ký gói Mobifone MFV250 vui lòng soạn tin nhắn theo cú pháp: MFV250 gửi 999
                    </li>
                  </ul>
                </div>
              </li>
              {/* <li className="mb-3">
                <div className="">
                  <div className="inline-block mb-2 font-bold uppercase">
                    CÁCH THỨC LỰA CHỌN NGƯỜI TRÚNG THƯỞNG
                  </div>{" "}
                  Người trúng thưởng phải thỏa các điều kiện sau:
                </div>
                <ul className="list-[disc] pl-3">
                  <li>
                    Dự đoán đúng Anh Trai và Đội thắng cuộc
                  </li>
                  <li>
                    Có số Dự đoán Tổng số lượt bình chọn chính xác, hoặc gần đúng nhất (số dự đoán gần đúng nhất phải thấp hơn Tổng số lượt bình chọn dành cho Anh Trai và Đội)
                  </li>
                  <li>
                    Trường hợp có nhiều hơn 100 khán giả thỏa 02 điều kiện trên
                    thì người trúng thưởng là người có thời gian bình chọn sớm
                    nhất
                  </li>
                </ul>
              </li>
              <li className="mb-3">
                <div className="mb-2 font-bold uppercase">
                  CÁCH THỨC NHẬN THƯỞNG
                </div>
                <ul className="list-[disc] pl-3">
                  <li>
                    Trong vòng 30 ngày kể từ ngày Công bố Anh Trai và Đội thắng cuộc, BTC sẽ thông báo với người trúng thưởng qua email hoặc số điện thoại được dùng để tham gia bình chọn
                  </li>
                  <li>
                    Trong vòng 7 ngày sau khi nhận được thông báo trúng thưởng, người trúng thưởng vui lòng cung cấp đầy đủ thông tin được yêu cầu
                  </li>
                  <li>
                    Sau khi nhận đầy đủ thông tin, BTC sẽ tiến hành trao thưởng
                  </li>
                </ul>
              </li>
              <li className="mb-3">
                <div className="mb-2 font-bold uppercase">
                  CÁC QUY ĐỊNH CHUNG
                </div>
                <ul className="list-[disc] pl-3">
                  <li>Giải thưởng không được quy đổi thành tiền mặt</li>
                  <li>
                    BTC không chịu trách nhiệm đối với các chi phí phát sinh
                    trong quá trình nhận thưởng như phí giao hàng và thuế thu
                    nhập không thường xuyên
                  </li>
                  <li>
                    Người tham gia phải xác nhận đồng ý Thể Lệ Tham Gia của
                    Chương Trình
                  </li>
                  <li>
                    Người tham gia phải cam kết các thông tin cung cấp cho
                    Chương Trình là chính xác, hợp pháp
                  </li>
                  <li>
                    Người tham gia phải đảm bảo có toàn quyền sở hữu hợp pháp
                    tài khoản VieON hoặc số điện thoại mà mình đã sử dụng để
                    tham gia Bình chọn. BTC không chịu trách nhiệm nếu xảy ra
                    bất kỳ tranh chấp nào
                  </li>
                  <li>
                    BTC sẽ không chịu trách nhiệm đối với các trường hợp thất
                    lạc giải thưởng do người trúng thưởng cung cấp không chính
                    xác, thiếu hoặc sai thông tin nhận giải
                  </li>
                  <li>
                    Trong mọi trường hợp, quyết định của BTC là quyết định cuối
                    cùng
                  </li>
                </ul>
              </li> */}
            </ol>
          </div>
          <button
            onClick={hidePopupInfoRule}
            className="absolute w-4 h-4 top-2 right-2"
            title="Close"
          >
            <svg
              className="w-4 h-auto"
              width={20}
              height={20}
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.8323 10.0156L19.6199 2.22773C20.1267 1.72117 20.1267 0.902117 19.6199 0.39555C19.1133 -0.111017 18.2943 -0.111017 17.7877 0.39555L9.99989 8.18339L2.21228 0.39555C1.70548 -0.111017 0.88667 -0.111017 0.380103 0.39555C-0.126701 0.902117 -0.126701 1.72117 0.380103 2.22773L8.16771 10.0156L0.380103 17.8034C-0.126701 18.31 -0.126701 19.129 0.380103 19.6356C0.632556 19.8883 0.964494 20.0152 1.29619 20.0152C1.62789 20.0152 1.95959 19.8883 2.21228 19.6356L9.99989 11.8478L17.7877 19.6356C18.0404 19.8883 18.3721 20.0152 18.7038 20.0152C19.0355 20.0152 19.3672 19.8883 19.6199 19.6356C20.1267 19.129 20.1267 18.31 19.6199 17.8034L11.8323 10.0156Z"
                fill="#fff"
              />
            </svg>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalInfo;
